// FNP-607: form-shape Zod schema for the ReconciliationReports filter (read-only module).
// The only filter is the channel (the listReconciliationReports channel-runStartedAt-index
// partition key). It is REQUIRED and non-clearable — the list is always scoped to exactly
// one channel (default STRIPE) — so the schema requires a non-empty value.
import {z} from 'zod';

export const FilterFormSchema = z.object({
    channel: z.string().min(1, 'Channel is required'),
});
